import { Box } from '@mui/material';

export default function MaintenanceBanner({ isVisible, message }) {
  if (!isVisible) return null;

  return (
    <Box
      sx={{
        position: 'relative', // changed from fixed
        width: '100%',
        bgcolor: '#ffea00',
        color: '#000',
        p: 1.5,
        fontSize: '1.5rem',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        boxShadow: 3,
        textAlign: 'center',
        zIndex: 1100,
        animation: 'slide-in 1.5s ease-out, shake 3s infinite alternate',
        '@keyframes slide-in': {
          from: { transform: 'translateY(-100%)' },
          to: { transform: 'translateY(0)' },
        },
        '@keyframes shake': {
          '0%': { transform: 'translateX(0)' },
          '25%': { transform: 'translateX(-2px)' },
          '50%': { transform: 'translateX(2px)' },
          '75%': { transform: 'translateX(-1px)' },
          '100%': { transform: 'translateX(1px)' },
        },
      }}
    >
      <span style={{ animation: 'blinker 3s linear infinite', display: 'inline-block' }}>🚧</span>{' '}
      {message}
    </Box>
  );
}